import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Hidden,
  Slide,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

import LanguageSelector from './LanguageSelector/LanguageSelector';
import Menu from './Menu/Menu';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  top: {
    padding: 0,
  },
  logo: {
    cursor: 'pointer',
  },
  menu: {
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 100,
    display: 'block',
    borderTop: '0.5px solid ' + theme.palette.secondary.main,
    borderBottom: '4px solid #F18D4E',
    backgroundColor: theme.palette.tertiary.main,
    padding: '0px 0%',
  },
  scrolledLogo: {
    position: 'fixed',
    top: 10,
    left: 50,
    zIndex: 150,
    height: 40,
    width: 'auto',
  },
  social: {
    '& div': {
      opacity: '.5',
      '&:hover': {
        opacity: 1,
      },
    },
  },
}));

const HeaderDesktop = ({ logo, logoSmall, menuData }) => {
  const classes = useStyles();
  const trigger = useScrollTrigger({ disableHysteresis: true });

  const location = useLocation();
  const path = location.pathname;
  const isPffLogo = logo.includes('pff');

  const {
    i18n: { language },
  } = useTranslation();

  const [showScrolledLogo, setShowScrolledLogo] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrolledLogo(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const mapPath = {
    'who-we-are': language === 'it' ? 'Chi siamo' : 'Who we are',
    contacts: language === 'it' ? 'Contatti' : 'Contacts',
    news: 'News & Download',
    applications: language === 'it' ? 'Applicazioni' : 'Applications',
    products: language === 'it' ? 'Prodotti' : 'Products',
    power: language === 'it' ? 'Applicazioni' : 'Applications',
    energyDataCenter: language === 'it' ? 'Applicazioni' : 'Applications',
    energyMaritime: language === 'it' ? 'Applicazioni' : 'Applications',
    stationary: language === 'it' ? 'Prodotti' : 'Products',
    maritime: language === 'it' ? 'Prodotti' : 'Products',
  };

  const menuRef = useRef(null);
  const [menuHeight, setMenuHeight] = useState(0);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    if (menuRef.current) {
      setMenuHeight(menuRef.current.getBoundingClientRect().height);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => setIsFixed(window.scrollY > 126);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Hidden mdDown>
      <Fragment>
        {/* Top Logo (grande) */}
        <Slide in={!trigger}>
          <Box width="100%" mt="1rem" pt="20px" pb="6px">
            <Container className={classes.top} maxWidth="md">
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <NavLink exact to="/">
                    <img
                      src={logo}
                      alt="Company logo"
                      className={classes.logo}
                      height={isPffLogo ? 100 : 34}
                      style={{ marginTop: '20px' }}
                    />
                  </NavLink>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Slide>

        {/* Logo piccolo scrollato (fisso a sinistra) */}
        {showScrolledLogo && (
          <Link to="/">
            <img src={logoSmall} alt="Logo" className={classes.scrolledLogo} />
          </Link>
        )}

        {/* Placeholder per evitare jump se sticky */}
        {isFixed && <div style={{ height: menuHeight }} />}

        {/* Menu principale */}
        {path !== '/_pages' && (
          <Box
            ref={menuRef}
            className={classes.menu}
            style={{
              position: isFixed ? 'fixed' : 'sticky',
              top: 0,
              left: 0,
              zIndex: 100,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Menu menuData={menuData} logoSmall={logoSmall} />
          </Box>
        )}

        {/* Titolo sottostante per le pagine interne */}
        {path !== '/' && (
          <Box
            style={{
              height: isFixed ? '30px' : '52px',
              display: 'flex',
              backgroundColor: '#FCE3CD',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0px 4.65%',
              position: isFixed ? 'fixed' : 'sticky',
              top: '55.8px',
              whiteSpace: 'nowrap',
              width: '100%',
              zIndex: 10,
            }}
          >
            <Box style={{ width: '960px' }}>
              <Typography
                style={{
                  color: '#2D3741',
                  fontSize: isFixed ? '1.3rem' : '1.5rem',
                  textTransform: 'capitalize',
                  fontFamily: 'Druk Wide Medium',
                }}
              >
                {mapPath[path.replace('/', '')]}
              </Typography>
            </Box>
          </Box>
        )}
      </Fragment>
    </Hidden>
  );
};

export default HeaderDesktop;
